import type { Action, Tournament } from '../../types.js';
import { applyTournament } from './tournament.js';
import { applyCourt } from './courts.js';
import { applyTeam } from './teams.js';
import { applyPhase } from './phases.js';
import { applyKo } from './ko.js';
import { applyMatch } from './matches.js';

/**
 * Eine Aktion auf den (schon kopierten) Zustand anwenden — verteilt nach
 * Aktionsfamilie, dem Teil vor dem Punkt im `type`. Jede Familie ist ein
 * eigenes Modul mit ihren Hilfsfunktionen; was mehrere brauchen, steht in
 * `shared.ts`. Liefert die Warnungen, wirft `EngineError` bei Ablehnung.
 */
const FAMILIEN: Record<string, (t: Tournament, action: Action) => string[]> = {
  tournament: applyTournament,
  competition: applyTournament,
  court: applyCourt,
  team: applyTeam,
  phase: applyPhase,
  group: applyPhase,
  ko: applyKo,
  match: applyMatch,
};

export function apply(t: Tournament, action: Action): string[] {
  // `undo` und `revert` haben keine Familie — sie werden in reduce()/replay() behandelt
  const familie = FAMILIEN[action.type.split('.')[0] as string];
  return familie ? familie(t, action) : [];
}
